import { createFileRoute, redirect } from "@tanstack/react-router";
import { apiFetch } from "@/lib/api";

export const Route = createFileRoute("/_authenticated/")({
  beforeLoad: async ({ context }) => {
    // Only create a new conversation if user is navigating to root
    if (!context.auth.user) return;
    const res = await apiFetch("/api/conversations", { method: "POST" });
    const { id } = (await res.json()) as { id: string };
    throw redirect({
      to: "/c/$conversationId",
      params: { conversationId: id },
    });
  },
});
